import _ from 'lodash';
import moment from 'moment';

import { KEY_FLEXIBLE, KEY_FLEXIBLE_CAMEL_CASE } from 'bundles/course-sessions/Constants';
import type { LearnerCourseSchedule } from 'bundles/course-sessions/types/LearnerCourseSchedule';

// Accepts any schedule-shaped object with a `scheduleTypeContent`, not just the hand-written
// LearnerCourseSchedule type: callers also pass the auto-generated naptime resource type
// (bundles/naptimejs/resources/__generated__/LearnerCourseSchedulesV1), whose `scheduleTypeContent`
// shape doesn't structurally match LearnerCourseSchedule's. The check below only needs
// `scheduleTypeContent` to exist and be inspectable via `_.has`, so it doesn't need either type's
// specific shape.
export function isSessionsV2Enabled(schedule?: { scheduleTypeContent?: unknown }): boolean {
  return !!(
    schedule &&
    schedule.scheduleTypeContent &&
    [KEY_FLEXIBLE, KEY_FLEXIBLE_CAMEL_CASE].some((key) => _.has(schedule.scheduleTypeContent, key))
  );
}

export function formatTimelineMessage(startDate?: number, endDate?: number): string {
  if (!startDate || !endDate) {
    return '';
  }

  const scheduleStartDate = moment(startDate);
  const scheduleEndDate = moment(endDate);

  return scheduleStartDate.format('LL') + ' - ' + scheduleEndDate.format('LL');
}

export function computeShiftedDates(
  startDate: number,
  endDate: number,
  shiftDuration: moment.DurationInputObject
): {
  startDate: number;
  endDate: number;
} {
  const shiftedStartDate = moment(startDate).add(shiftDuration).valueOf();
  const shiftedEndDate = moment(endDate).add(shiftDuration).valueOf();

  return {
    startDate: shiftedStartDate,
    endDate: shiftedEndDate,
  };
}

export function getSessionsV2CourseTimelineMessage(schedule?: Partial<LearnerCourseSchedule>) {
  let message = '';
  if (schedule && schedule.startsAt && schedule.endsAt) {
    message = formatTimelineMessage(schedule.startsAt, schedule.endsAt);
  }

  return message;
}
